<template>
    <div>
        <v-checkbox
            hide-details
            color="default"
            :on-icon="mdiCheckboxOutline"
            :off-icon="mdiCheckboxBlankOutline"
            class="mt-0"
            :input-value="filterValue.selected"
            @change="$emit('change')"
            :class="{ 'ml-8': hasSelectedFilterValue && !filterValue.selected }"
        >
            <template #label>
                {{ formatFilterValue(filterValue) }}
                <template v-if="!filterValue.selected && filterValue.frequency !== null">({{ filterValue.frequency }})</template>
            </template>
        </v-checkbox>
    </div>
</template>

<script lang="ts">
import { mdiCheckboxBlankOutline, mdiCheckboxOutline } from '@mdi/js';
import { last } from 'lodash-es';
import { PropType } from 'vue';
import { Vue } from 'vue-property-decorator';
import { FilterMetadata } from '../../../../../../declarations/result';

export default Vue.extend({
    name: 'CatFilterValue',
    props: {
        filterValue: {
            type: Object as PropType<FilterMetadata>,
            required: true,
        },
        hasSelectedFilterValue: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        formatFilterValue(filterValue: FilterMetadata): string {
            const filterValueString = filterValue.value as string;

            if (filterValue.selected) {
                return filterValueString.replaceAll('_', ' → ');
            } else {
                return last(filterValueString.split('_'));
            }
        },
    },
    data() {
        return {
            mdiCheckboxBlankOutline,
            mdiCheckboxOutline,
        };
    },
});
</script>
